import { useMemo, useState } from "react";

import {
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_SIZE_OPTIONS,
} from "../static/pagination";

/**
 * Use page size options hook to get pageSize options and save pageSize in local storage if needed
 *
 * @param {array} dataLength
 * @param {number} pageSize
 * @param {array} pageSizeOptions
 * @param {boolean} saveInStore
 * @returns {array} [pageSize, setPageSize, pageSizeOptions]
 */
const usePageSizeOptions = (
  dataLength,
  pageSize = DEFAULT_PAGE_SIZE,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
  saveInStore = false
) => {
  const [currentPageSize, setCurrentPageSize] = useState(() => {
    if (saveInStore) {
      const storedPageSize = localStorage.getItem("pageSize");
      if (!storedPageSize) return pageSize;

      return storedPageSize === "All" ? dataLength : parseInt(storedPageSize);
    }

    return pageSize;
  });

  const changePageSize = (newPageSize) => {
    if (saveInStore) {
      localStorage.setItem(
        "pageSize",
        newPageSize === dataLength ? "All" : newPageSize
      );
    }
    setCurrentPageSize(newPageSize);
  };

  const filteredPageSizeOptions = useMemo(() => {
    const filtered = pageSizeOptions.filter((option) => option <= dataLength);
    return [...filtered, { value: dataLength, label: "All" }];
  }, [dataLength, pageSizeOptions]);

  return [currentPageSize, changePageSize, filteredPageSizeOptions];
};

export default usePageSizeOptions;
